import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Container, Grid, Paper, Box } from "@mui/material";
import Layout from "../Layout";
import { fetchRequest } from "../../store/receipt/actions";
import { ApplicationState } from "../../store";
import ReceiptTable from "./receiptTable/ReceiptTable";
import PageHeading from "../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../common/progressIndicator/ProgressIndicator";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";

export default function Receipt() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();
  const session = useSession();

  useEffect(() => {
    dispatch(fetchRequest(null));
  }, []);

  const { loading, data } = useSelector(
    (state: ApplicationState) => state.receipt
  );
  const receiptData =
    data?.data?.filter((data) => data.attributes.Type === "HTML") || [];

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading
                  entity="Receipt"
                  heading="Receipt"
                  primaryButtonText="Add new Receipt"
                  primaryButtonClickHandler={() => history.push("/receipt/new")}
                />
              </Paper>
              <Box my={2}>
                <Paper>
                  {loading ? (
                    <ProgressIndicator />
                  ) : (
                    <ReceiptTable receiptData={receiptData} />
                  )}
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
